import React, { FunctionComponent, useState } from 'react';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';

import Button from '../../../UI/Button';
import Modal from '../../../UI/Modal';
import BalanceForm from './BalanceForm';
import { parsePrice } from '../../../../utils/utils';
import { sendEvent2 } from '../../../../utils/tracking';

const Recharge: FunctionComponent<{ tagId: string; vehicle: string; recharge: boolean; minBal: string }> = ({
  tagId,
  vehicle,
  recharge,
  minBal,
}) => {
  const [modalState, setModalState] = useState(false);

  const walletBalance = useSelector((state: any) => _get(state, 'fasTag.balance', ''));

  const toggleModal = () => {
    if (modalState) {
      sendEvent2(
        'close_btn',
        {
          event_action: 'click',
          event_category: 'maintain_min_bal_pop_up',
          screen_name: 'ft_homescreen',
          target_product: 'fastag',
          event_platform: 'web',
        },
        true,
      );
    }
    setModalState((prevState) => !prevState);
  };

  const updateAction = (modalState: boolean) => setModalState(modalState);

  return (
    <div className="z1">
      <Button
        disabled={!recharge}
        variant="text"
        color="#304FFE"
        size="small"
        style={{ textDecoration: 'underline', padding: 0, textAlign: 'left' }}
        clickHandler={() => {
          toggleModal();
          sendEvent2(
            'maintain_min_bal_btn',
            {
              event_action: 'click',
              event_category: 'vehicle_card',
              screen_name: 'ft_homescreen',
              miscellaneous: JSON.stringify({
                minimum_balance: parseFloat(minBal),
              }),
              target_product: 'fastag',
              event_platform: 'web',
            },
            true,
          );
        }}
      >
        {`Maintain Bal. ${parsePrice({ price: parseFloat(minBal) })}`}
      </Button>
      <Modal
        isOpen={modalState}
        onClose={() => {
          toggleModal();
        }}
      >
        <BalanceForm
          tagId={tagId}
          vehicle={vehicle}
          updateAction={updateAction}
          recharge={recharge}
          walletBalance={walletBalance}
        />
      </Modal>
    </div>
  );
};

export default Recharge;
